import { render, staticRenderFns } from "./customer-visit-history-list.vue?vue&type=template&id=f622d98a&scoped=true&"
import script from "./customer-visit-history-list.vue?vue&type=script&lang=js&"
export * from "./customer-visit-history-list.vue?vue&type=script&lang=js&"
import style0 from "./customer-visit-history-list.vue?vue&type=style&index=0&id=f622d98a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f622d98a",
  null
  
)

export default component.exports